import Vue from 'vue'

Vue.use(require('vue-pusher'), {
  api_key: process.env.VUE_APP_PUSHER_KEY,
  options: {
    cluster: 'ap1',
    encrypted: true,
  },
})
